<template>
  <div class="container module">
    <page-header v-if="banner" type="image" :height="750" :image="banner">
      <template v-slot:searchbox>
        <div class="search-form">
          <div class="title">Image</div>
          <el-input
            style="width: 350px"
            placeholder="Keywords goes here"
          ></el-input>
        </div>
      </template>
    </page-header>

    <div class="navi">
      <page-navbar class="inn" />
    </div>

    <filters
      :showFilter="showFilter"
      :columns1="cats"
      columns1_title="Product Categories"
      :columns2="types"
      columns2_title="Type"
      :total="total"
      @resetItems="resetItems"
      @searchItems="searchItems"
      @toggleStatus="toggleFilterFormStatus"
    >
    </filters>

    <album-list :items="items" />

    <div class="section">
      <div class="loadmore" v-if="hasmore">
        <div class="btn" @click="loadMore">Load More</div>
      </div>
    </div>

    <page-footer />
  </div>
</template>
<style lang="scss" scoped>
.module {
  background-color: #fff;
}
</style>

<script>
import PageHeader from "../components/PageHeaderV2.vue";
import PageFooter from "../components/PageFooter.vue";
import ComHeader from "../components/ComHeader.vue";
import PageNavbar from "../components/PageNavbar.vue";
import Filters from "../components/Filters.vue";
import AlbumList from "../components/AlbumList.vue";
import Api from "../utils/api";
import { mapGetters } from "vuex";
export default {
  name: "Album",
  components: {
    PageFooter,
    ComHeader,
    PageNavbar,
    Filters,
    AlbumList,
    PageHeader,
  },
  methods: {
    toggleFilterFormStatus() {
      this.showFilter = !this.showFilter;
    },
    resetItems() {
      this.items = [];
      this.showFilter = false;
      this.queryList({ pg: 1 });
    },

    searchItems(args) {
      let options = {
        scene_cat: args["selected_col1"],
        type_cat: args["selected_col2"],
        pg: 1,
      };
      this.showFilter = false;
      this.items = [];
      this.queryList(options);
    },
    loadMore() {
      if (this.hasmore) {
        let pg = this.pg + 1;
        this.queryList({ pg });
      }
    },
    queryList(args) {
      Api.getAlbumList(args)
        .then((res) => {
          let items = this.items;
          this.items = items.concat(res.items);
          this.total = res.total;
          this.hasmore = res.hasmore;
          this.pg = Number(res.pg);
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
  },
  created() {
    this.queryList({ pg: 1 });
  },
  computed: {
    ...mapGetters({
      cats: "getProductCats",
      types: "getTypeCats",
      getPageData: "getPageData",
    }),
    banner() {
      let key = "images";
      let page = this.getPageData;
      return !!page[key] ? page[key] : false;
    },
  },

  data() {
    return {
      showFilter: false,
      brand: "",
      scene_cat: 0,
      type_cat: 0,
      total: 0,
      hasmore: false,
      items: [],
    };
  },
};
</script>
